var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.24 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #898989;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u6587\\u5B57",
    "data-name": "\\u6587\\u5B57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.12,0c1.37,0,2.58.55,3.47,1.45.89.89,1.45,2.13,1.45,3.5s-.55,2.58-1.45,3.47c-.39.42-.87.74-1.39,1,1.39.37,2.65,1.1,3.65,2.1,1.47,1.47,2.39,3.5,2.39,5.73v.97c0,.5-.21.95-.53,1.26-.32.34-.79.53-1.26.53H1.79c-.5,0-.95-.18-1.26-.53-.34-.32-.53-.76-.53-1.26v-.97c0-2.23.92-4.26,2.39-5.73.97-1,2.23-1.73,3.63-2.1-.5-.26-1-.58-1.39-1-.89-.89-1.45-2.13-1.45-3.47s.55-2.6,1.45-3.5c.89-.89,2.13-1.45,3.5-1.45h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c1d7fb606777e12c5db8ca18258d00ec.svg";
export { ForwardRef as ReactComponent };